import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

export const STATUS = {
  agendado: { label: "Agendado", cls: "bg-yellow-500/15 border-yellow-500/30 text-yellow-300", dot: "bg-yellow-400" },
  montado: { label: "Montado", cls: "bg-emerald-500/15 border-emerald-500/30 text-emerald-300", dot: "bg-emerald-400" },
  desmontado: { label: "Desmontado", cls: "bg-indigo-500/15 border-indigo-500/30 text-indigo-300", dot: "bg-indigo-400" },
};

export const fmtDate = (iso, pattern = "dd 'de' MMM, yyyy") => (iso ? format(parseISO(iso), pattern, { locale: ptBR }) : "—");
export const fmtDateTime = (iso, time) => `${fmtDate(iso, "EEE, dd/MM")}${time ? ` · ${time}` : ""}`;

export const mapLink = (ev) =>
  ev.map_url || `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent([ev.location, ev.address].filter(Boolean).join(", "))}`;

export const phoneLink = (p) => `tel:${(p || "").replace(/[^\d+]/g, "")}`;
export const waLink = (p) => {
  const d = (p || "").replace(/\D/g, "");
  return `https://wa.me/${d.length <= 11 ? `55${d}` : d}`;
};

export const toKey = (d) => format(d, "yyyy-MM-dd");

export const BRANCHES = { curitiba: "Curitiba", litoral_norte: "Litoral Norte", sao_paulo: "São Paulo" };
